import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';

export const SanityRelatedContent = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('relatedContent'),
  _key: z.string().optional(),
  headline: z.string(),
  items: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      href: z.string(),
      thumbnailImage: SanityImage,
      excerpt: z.string(),
    }),
  ),
});
export type SanityRelatedContent = z.infer<typeof SanityRelatedContent>;

export const relatedContent = groq`{
  _type,
  headline,
  items[]-> {
    '_key': _id,
    title,
    excerpt,
    thumbnailImage ${image},
    _type == 'post' => {
      'href': '/blog/' + slug.current,
    },
    _type == 'resource' => {
      'href': '/resources/' + slug.current,
    },
    _type == 'caseStudy' => {
      'href': '/case-studies/' + slug.current,
    },
  },
}`;
